import {
  API_ENDPOINT,
  useClientApiV1NotesIdUpdateMutation,
} from '../../resources/@types/uccSchema';

function useNoteIdUpdateMutation(
  id: string,
  options?: Parameters<typeof useClientApiV1NotesIdUpdateMutation>[0]['options'],
) {
  return useClientApiV1NotesIdUpdateMutation({
    url: API_ENDPOINT.CLIENT_V1_NOTES_ID(id),
    options,
  });
}

export const getUseNoteIdUpdateMutationQueryKey = (id: string) => [
  [API_ENDPOINT.CLIENT_V1_NOTES_ID(id), 'update'],
];

export default useNoteIdUpdateMutation;
